export const CHATNEX_URL = 'https://chatnex.in';

export const CHATNEX_FEATURES = [
  {
    title: 'Embedded Signup',
    description:
      'Onboard customers instantly with a secure, seamless, and fully integrated signup experience powered by advanced APIs, with WhatsApp Coexistence support enabled.'
  },
  {
    title: 'WhatsApp Live Chat',
    description:
      'Connect with customers instantly through secure, seamless, and fully integrated WhatsApp messaging powered by advanced APIs, with real-time live chat support enabled.'
  },
  {
    title: 'Auto Reply ChatBot',
    description:
      'Provide 24/7 customer support through secure, seamless, and fully integrated AI-powered messaging powered by advanced APIs, with automated response workflow support enabled.'
  },
  {
    title: 'Template Management',
    description:
      'Create, edit, and manage approved message templates through a secure, seamless, and fully integrated dashboard with WhatsApp template and media carousel support enabled.'
  },
  {
    title: 'Campaign Management',
    description:
      'Create, manage, and optimize campaigns through a secure, seamless, and fully integrated system with real-time tracking and performance analytics support enabled.'
  },
  {
    title: 'Contacts Import/Export',
    description:
      'Import, export, and manage contacts through a secure, seamless, and fully integrated system powered by advanced APIs, with bulk processing and data synchronization support enabled.'
  },
  {
    title: 'Bot Flow Maker',
    description:
      'Design and automate messaging workflows through a secure, seamless, and fully integrated system powered by advanced APIs, with drag-and-drop flow builder support enabled.'
  },
  {
    title: 'Assign Team Member',
    description:
      'Assign and manage team members through a secure, seamless, and fully integrated system powered by advanced APIs, with role-based access and collaboration support enabled.'
  },
  {
    title: 'Non-Template Campaigns',
    description:
      'Send preset messages within the 24-hour session window through a secure, seamless, and fully integrated system with real-time delivery and engagement support enabled.'
  },
  {
    title: 'Carousel Template Message',
    description:
      'Create and send carousel template campaign messages through a secure, seamless, and fully integrated system with rich media and interactive content support enabled.'
  },
  {
    title: 'API & Integrations',
    description:
      'Integrate securely with third-party systems through a seamless, robust, and fully integrated platform with standard REST connectivity and automation support enabled.'
  },
  {
    title: 'Marketing Lite API',
    description:
      'Send marketing messages efficiently through a secure, seamless, and fully integrated system powered by advanced APIs, with lite API support and scalable campaign delivery enabled.'
  },
  {
    title: 'Security & Authentication',
    description:
      'Protect user access through a secure, seamless, and fully integrated system with multi-layer authentication and enhanced data protection support enabled.'
  },
  {
    title: 'Analytics & Performance',
    description:
      'Track and optimize system performance through a secure, seamless, and fully integrated platform with real-time analytics and actionable insights support enabled.'
  },
  {
    title: 'AI & Chatbot Automation',
    description:
      'Automate customer interactions through a secure, seamless, and fully integrated system with AI-driven workflows and intelligent chatbot support enabled.'
  },
  {
    title: 'Template Bots Reply',
    description:
      'Automate message responses through a secure, seamless, and fully integrated system with template-based bot workflows and smart reply support enabled.'
  },
  {
    title: 'WhatsApp Coexistence API',
    description:
      'Connect and manage WhatsApp Business App and API through a secure, seamless, and fully integrated system with coexistence and unified messaging support enabled.'
  },
  {
    title: 'Multi-Number Support',
    description:
      'Manage multiple WhatsApp numbers through a secure, seamless, and fully integrated system with unified inbox and multi API account handling support enabled.'
  },
  {
    title: 'Full REST API System',
    description:
      'Integrate and manage systems through a secure, seamless, and fully integrated platform with campaign, contact, messaging, webhook, and lite API support enabled.'
  },
  {
    title: 'Label-Based Targeting',
    description:
      'Target and segment audiences through a secure, seamless, and fully integrated system powered by advanced APIs, with label-based filtering and precise campaign delivery support enabled.'
  },
  {
    title: 'WooCommerce Order Update',
    description:
      'Automatically send real-time order status updates, payment confirmations, shipping notifications, and delivery alerts to customers via WhatsApp through a secure, seamless, and fully integrated WooCommerce connection.'
  }
];

export const WHATSAPP_COMMERCE_FEATURES = [
  {
    title: 'WhatsApp Ecommerce Catalog',
    description:
      'Showcase products, prices, and images inside WhatsApp so customers can browse and order without leaving the chat.'
  },
  {
    title: 'WhatsApp Payments',
    description:
      'Collect payments on WhatsApp with payment links, UPI, cards, and Razorpay-style checkout for faster order confirmation.'
  },
  {
    title: 'Abandoned Cart Recovery',
    description:
      'Send automated WhatsApp reminders for unfinished carts and recover lost ecommerce sales with one-tap checkout links.'
  },
  {
    title: 'Shopify Order Updates',
    description:
      'Push Shopify order, payment, packing, and delivery updates to customers on WhatsApp in real time.'
  },
  {
    title: 'Click-to-WhatsApp Ads',
    description:
      'Run Meta ads that open a WhatsApp chat so leads land directly in your ChatNex inbox, ready for bots or your team.'
  },
  {
    title: 'WhatsApp Flows',
    description:
      'Collect addresses, order details, and feedback with native WhatsApp Flows instead of long back-and-forth messages.'
  },
  {
    title: 'COD Order Confirmation',
    description:
      'Reduce fake COD orders with WhatsApp confirmation, address verification, and automated cancel or dispatch messages.'
  },
  {
    title: 'Shipping & Delivery Alerts',
    description:
      'Notify customers of dispatch, out-for-delivery, and delivered status with tracking links on WhatsApp.'
  },
  {
    title: 'Click-to-Chat Buttons',
    description:
      'Add WhatsApp chat buttons on websites, landing pages, and Google Business profiles to start conversations instantly.'
  },
  {
    title: 'QR Code Chat',
    description:
      'Let walk-in customers scan a WhatsApp QR code to chat, view catalogs, and place orders from stores or events.'
  },
  {
    title: 'OTP & Transaction Alerts',
    description:
      'Send login OTPs, payment receipts, and transactional alerts on official WhatsApp API with high delivery rates.'
  },
  {
    title: 'Retargeting & Reorder Campaigns',
    description:
      'Re-engage past buyers with offers, restock alerts, and reorder campaigns using labels and customer segments.'
  }
];
